module.exports = __webpack_public_path__ + "img/02_logo.68f046e7.png";